var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8933 0.34681C32.6492 0.124007 32.3305 0.000488281 32 0.000488281C31.6695 0.000488281 31.3508 0.124007 31.1067 0.34681C30.1627 1.19748 8 21.4561 8 40.0001C8 53.2321 18.7653 64.0001 32 64.0001C45.2347 64.0001 56 53.2321 56 40.0001C56 21.4561 33.8373 1.19748 32.8933 0.34681Z",
    fill: "#303C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 61.3335C20.2374 61.3335 10.6667 51.7629 10.6667 40.0002C10.6667 24.6615 27.8454 7.16819 32.0001 3.16553C36.1547 7.16553 53.3334 24.6482 53.3334 40.0002C53.3334 51.7629 43.7627 61.3335 32.0001 61.3335Z",
    fill: "#BBDEFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 61.3335C20.2374 61.3335 10.6667 51.7629 10.6667 40.0002C10.6667 24.6615 27.8454 7.16819 32.0001 3.16553C36.1547 7.16553 53.3334 24.6482 53.3334 40.0002C53.3334 51.7629 43.7627 61.3335 32.0001 61.3335Z",
    fill: "url(#paint0_linear_632_14969)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0293 55.5786C23.3973 55.5786 16.3733 46.9546 16.3733 36.3573C16.3733 22.536 28.9813 6.77597 32.0293 3.16797C35.0773 6.7733 47.6853 22.5253 47.6853 36.3573C47.6853 46.9546 40.6613 55.5786 32.0293 55.5786Z",
    fill: "url(#paint1_linear_632_14969)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0453 51.9573C22.2693 51.9573 16.7546 45.5306 16.7546 37.6293C16.7546 27.328 26.6533 15.5786 29.0453 12.8906C31.4373 15.5786 41.336 27.32 41.336 37.6293C41.336 45.528 35.8213 51.9573 29.0453 51.9573Z",
    fill: "url(#paint2_linear_632_14969)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.584 50.1494C42.7651 50.1494 43.7226 49.1919 43.7226 48.0107C43.7226 46.8296 42.7651 45.8721 41.584 45.8721C40.4028 45.8721 39.4453 46.8296 39.4453 48.0107C39.4453 49.1919 40.4028 50.1494 41.584 50.1494Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.5572 44.6799C37.217 44.6799 37.7519 44.145 37.7519 43.4852C37.7519 42.8254 37.217 42.2905 36.5572 42.2905C35.8974 42.2905 35.3625 42.8254 35.3625 43.4852C35.3625 44.145 35.8974 44.6799 36.5572 44.6799Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53.3332C24.648 53.3332 18.6667 47.3518 18.6667 39.9998C18.6667 39.6462 18.5262 39.3071 18.2761 39.057C18.0261 38.807 17.687 38.6665 17.3333 38.6665C16.9797 38.6665 16.6406 38.807 16.3905 39.057C16.1405 39.3071 16 39.6462 16 39.9998C16 48.8238 23.176 55.9998 32 55.9998C32.3536 55.9998 32.6928 55.8594 32.9428 55.6093C33.1929 55.3593 33.3333 55.0201 33.3333 54.6665C33.3333 54.3129 33.1929 53.9737 32.9428 53.7237C32.6928 53.4736 32.3536 53.3332 32 53.3332Z",
    fill: "#303C42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8933 0.34681C32.6492 0.124007 32.3305 0.000488281 32 0.000488281C31.6695 0.000488281 31.3508 0.124007 31.1067 0.34681C30.1627 1.19748 8 21.4561 8 40.0001C8 53.2321 18.7653 64.0001 32 64.0001C45.2347 64.0001 56 53.2321 56 40.0001C56 21.4561 33.8373 1.19748 32.8933 0.34681Z",
    fill: "url(#paint3_linear_632_14969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_632_14969",
    x1: 14.8001,
    y1: 25.3309,
    x2: 53.8801,
    y2: 43.5549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_632_14969",
    x1: 19.008,
    y1: 23.9706,
    x2: 49.2613,
    y2: 38.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_632_14969",
    x1: 29.0453,
    y1: 51.9573,
    x2: 29.0453,
    y2: 12.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_632_14969",
    x1: 12.4347,
    y1: 24.0481,
    x2: 56.3653,
    y2: 44.5335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.2bb6a948ca79c6a8c64143abbc0e4e35.svg";
export { ForwardRef as ReactComponent };